import { Button } from '@kerfjs/ui/button';
import { space } from '@kerfjs/ui/css-values';
import { Disclosure } from '@kerfjs/ui/disclosure';
import { List } from '@kerfjs/ui/list';
import { ListInsetControl } from '@kerfjs/ui/list-inset-control';
import { Row } from '@kerfjs/ui/row';
import { Spacer } from '@kerfjs/ui/spacer';
import { Text } from '@kerfjs/ui/text';
import { attr, type SafeHtml } from 'kerfjs';

import { deleteConfirmOpen, exportState } from '../../data/state.js';
import { DeleteOrganizationDialog } from './delete-organization-dialog.js';

export const DATA_PRIVACY_ACTIONS = {
  open: attr('data-action', 'delete-org-open'),
} as const;

/** Settings controls for organization export and deletion. */
export function DataPrivacyView({ orgName }: { orgName: string }): SafeHtml {
  const state = exportState.value;
  return (
    <div class="data-privacy-view data-privacy-page">
      <List gap="m">
        <ListInsetControl sides="rl">
          <Text tone="quiet" size="compact">
            Export everything this organization holds (JSON + files), or delete the organization. See the{' '}
            <a href="/privacy">privacy &amp; data</a> page.
          </Text>
        </ListInsetControl>
        <Row vAlign="middle" gap="xs" wrap controlInsets="rl">
          <Button
            tone="neutral"
            emphasis="primary"
            size="default"
            action="export-org"
            loading={state.status === 'running' ? true : undefined}
            disabled={state.status === 'running' ? true : undefined}
          >
            Download Organization Data
          </Button>
        </Row>
      </List>

      <Spacer height={space('xl')} />
      <Disclosure title="Danger Zone" appearance="framed">
        <Button tone="danger" emphasis="plain" action={DATA_PRIVACY_ACTIONS.open.value}>
          Delete Organization…
        </Button>
      </Disclosure>

      {deleteConfirmOpen.value ? <DeleteOrganizationDialog orgName={orgName} /> : null}
    </div>
  );
}
